import React from "react";
import PricingTable from "./PricingTable";
import BoldCell from "./BoldCell";
import Tick from "../Tick";

type EnvironmentsTableProps = {
  currency: string
};

const EnvironmentsTable: React.FC<EnvironmentsTableProps> = ({ currency, ...props }) => {
  return (
    <PricingTable>
      <tbody>
        <tr>
          <BoldCell>Number of environments</BoldCell>
          <td>On demand</td>
        </tr>
        <tr>
          <BoldCell>Paused environments</BoldCell>
          <td>Environments will pause automatically after 15 days of inactivity, and we'll only charge for the storage (disk, object storage, and backups) on the environment, not on CPU or memory.</td>
        </tr>
        <tr>
          <BoldCell>Custom domains on preview environments</BoldCell>
          <td>
            <Tick />
          </td>
        </tr>
        <tr>
          <BoldCell>High-availability option</BoldCell>
          <td>Application and services</td>
        </tr>
        {/* <tr>
          <BoldCell>Build minutes (deploy, Source Operations)</BoldCell>
          <td>300/project/month</td>
        </tr> */}
        {/* <tr>
          <BoldCell comingSoon>Premium services</BoldCell>
          <td css={comingSoon}>Elasticsearch Enterprise and MongoDB Enterprise (coming soon)</td>
        </tr> */}
      </tbody>
    </PricingTable>
  );
};

export default EnvironmentsTable;
